import {FormEvent} from 'react';
import {useI18n} from '../../../../common/providers/I18nProvider';
import Alert from '../../../../common/components/alerts/Alert';
import {WithChildren} from '../../../../common/helpers';

interface Props {
	title: string;
	showTitle?: boolean;
	lineUnderTitle?: boolean;
	subtitle?: string;
	afterSubtitle?: string;
	handleSubmit?: (e?: FormEvent<HTMLFormElement> | undefined) => void;
	status?: string;
}

export default function Form({
	title,
	subtitle,
	afterSubtitle,
	handleSubmit,
	status,
	children,
	showTitle = true,
	lineUnderTitle = false,
}: Props & WithChildren) {
	const {i18n} = useI18n();

	return (
		<form className='form w-100 py-8 px-4 sm:py-6 sm:px-4 lg:py-12 lg:px-9' onSubmit={handleSubmit} noValidate>
			{showTitle && (
				<div className='text-auth-black mb-4 lg:mb-6'>
					<h1 className='text-lg sm:text-base lg:text-2.5xl font-bold sm:font-medium lg:font-bold'>{i18n(title)}</h1>
					{lineUnderTitle && <hr className='mt-1' />}
				</div>
			)}

			{subtitle && (
				<p className='mb-4 text-center text-xs text-[#808080]'>
					{i18n(subtitle)}
					{afterSubtitle && (
						<>
							<br />
							<span>{afterSubtitle}</span>
						</>
					)}
				</p>
			)}

			{status && <Alert message={status} extraClasses='mb-4' error />}

			{children}
		</form>
	);
}
